const SupportedLocaleForDayJS = {
  'es': () => import('dayjs/locale/es'),
  'en': () => import('dayjs/locale/en'),
  'fr': () => import('dayjs/locale/fr'),
  'pl': () => import('dayjs/locale/pl'),
  'ru': () => import('dayjs/locale/ru'),
  'id': () => import('dayjs/locale/id'),
  'ms': () => import('dayjs/locale/ms'),
  'tl': () => import('dayjs/locale/tl-ph'),
  'de': () => import('dayjs/locale/de'),
  'vi': () => import('dayjs/locale/vi'),
  'th': () => import('dayjs/locale/th'),
  'az': () => import('dayjs/locale/az'),
  'pt-br': () => import('dayjs/locale/pt-br'),
  'zh-CN': () => import('dayjs/locale/zh-cn'),
  'zh-TW': () => import('dayjs/locale/zh-tw'),
  'tr': () => import('dayjs/locale/tr'),
  'it': () => import('dayjs/locale/it'),
  'ja': () => import('dayjs/locale/ja'),
  'kk': () => import('dayjs/locale/kk'),
};

export default SupportedLocaleForDayJS;
